import { useState } from 'react'
import { useSnapshot } from '../state/TelephonyProvider'
import { useCommand } from '../state/useCommand'
import { TelephonyCommandNames } from '../contract'
import { prettyNumber } from './_shared'
import { IconPhoneIncoming, IconPhoneCheck, IconPhoneX, IconX } from '../ui/icons'

// Caller-ID screen-pop. Driven by the existing call_info stream (inbound + ringing) — no new
// contract event needed. Shows the newest un-dismissed incoming ringer with answer/reject.
export function ScreenPop() {
  const { calls } = useSnapshot()
  const run = useCommand()
  const [dismissed, setDismissed] = useState<Set<string>>(new Set())

  const incoming = calls.find(
    (c) => c.direction === 'inbound' && c.status === 'ringing' && !dismissed.has(c.uniqueId)
  )
  if (!incoming) return null

  const name = incoming.callerIdName || prettyNumber(incoming.callerIdNumber) || incoming.channel
  const dismiss = () => setDismissed((s) => new Set(s).add(incoming.uniqueId))

  return (
    <div className="sb-pop" role="alert" aria-live="assertive">
      <span className="sb-pop-ico"><IconPhoneIncoming size={22} stroke={1.75} /></span>
      <div className="sb-pop-main">
        <div className="sb-pop-name">{name}</div>
        <div className="sb-pop-sub">Incoming · {prettyNumber(incoming.callerIdNumber) || 'unknown'} → ext {incoming.extension}</div>
      </div>
      <div className="sb-pop-actions">
        <button className="btn btn-on"
          onClick={() => { void run({ command: TelephonyCommandNames.Answer, params: { channel: incoming.channel } }, { successMessage: `Answered ${name}` }); dismiss() }}>
          <IconPhoneCheck size={14} stroke={1.75} /> answer
        </button>
        <button className="btn btn-danger"
          onClick={() => { void run({ command: TelephonyCommandNames.Reject, params: { channel: incoming.channel } }); dismiss() }}>
          <IconPhoneX size={14} stroke={1.75} /> reject
        </button>
        <button className="sb-iconbtn" aria-label="Dismiss" onClick={dismiss}>
          <IconX size={15} stroke={2} />
        </button>
      </div>
    </div>
  )
}
